const APPLICATION_CANCELLED = 0;
const APPLICATION_STARTED = 1;
const APPLICATION_MODEL_PRE_DECLINED = 2;
const APPLICATION_AUTO_DECLINE_OVERRULED = 3;
const APPLICATION_CONDITIONS_CALCULATED = 4;
const APPLICATION_CONDITIONS_SELECTED = 5;
const APPLICATION_CONTRACT_READY = 6;
const APPLICATION_CONTRACT_SIGNED = 7;
const APPLICATION_PENDING_DATA_SOURCES = 8;
const APPLICATION_PENDING_PROOF_OF_INCOME = 9;
const APPLICATION_PENDING_MOBILE_COLLATERAL_INSTALLATION = 10;
const APPLICATION_PENDING_MOBILE_COLLATERAL_ACTIVATION = 11;
const APPLICATION_MODEL_DECLINED = 12;
const APPLICATION_PENDING_DOCUMENT_SUBMISSION = 13;
const APPLICATION_PENDING_DATA_CAPTURE_APP_INSTALLATION = 14;
const APPLICATION_PENDING_ACCEPTABLE_BANK = 15;
const APPLICATION_PENDING_CREDIT_POLICY = 29;
const UNDERWRITING_READY = 44;
const UNDERWRITING_STARTED = 40;
const APPLICATION_MANUALLY_DECLINED = 41;
const APPLICATION_APPROVED = 43;
const IDENTIFICATION_UNDERWRITING_STARTED = 45;
const INCOME_UNDERWRITING_STARTED = 46;
const UNDERWRITING_PENDING_BIOMETRY_IDENTITY = 47;
const UNDERWRITING_PENDING_TOKEN_CLICK = 48;
const APPROVE_READY = 51;
const APPROVED = 59;
const FORMALIZATION_SUBMITTED = 60;
const FORMALIZATION_FAILED = 61;
const FORMALIZATION_COMPLETED = 62;
const DISBURSEMENT_SUBMITTED = 63;
const DISBURSEMENT_FAILED = 64;
const DISBURSEMENT_COMPLETED = 65;
const CANCELLED_BY_DISBURSEMENT_RETURN = 66;
const DISBURSEMENT_RETURN_REQUESTED = 70;
const DISBURSEMENT_RETURNED = 71;
const CURRENT = 80;
const LATE = 81;
const COLLECTION_SUSPENDED = 90;
const RESCHEDULED = 82;
const CURED = 83;
const RECOVERED = 84;
const RE_PAYMENT_PENDING_CONFIRMATION = 85;
const RENEGOTIATED = 86;
const ON_TIME_FULLY_PAID_OFF = 100;
const LATE_FULLY_PAID_OFF = 102;
const CHARGED_OFF = 110;

export {
  APPLICATION_CANCELLED,
  APPLICATION_STARTED,
  APPLICATION_MODEL_PRE_DECLINED,
  APPLICATION_AUTO_DECLINE_OVERRULED,
  APPLICATION_CONDITIONS_CALCULATED,
  APPLICATION_CONDITIONS_SELECTED,
  APPLICATION_CONTRACT_READY,
  APPLICATION_CONTRACT_SIGNED,
  APPLICATION_PENDING_DATA_SOURCES,
  APPLICATION_PENDING_PROOF_OF_INCOME,
  APPLICATION_PENDING_MOBILE_COLLATERAL_INSTALLATION,
  APPLICATION_PENDING_MOBILE_COLLATERAL_ACTIVATION,
  APPLICATION_MODEL_DECLINED,
  APPLICATION_PENDING_DOCUMENT_SUBMISSION,
  APPLICATION_PENDING_DATA_CAPTURE_APP_INSTALLATION,
  APPLICATION_PENDING_ACCEPTABLE_BANK,
  APPLICATION_PENDING_CREDIT_POLICY,
  UNDERWRITING_READY,
  UNDERWRITING_STARTED,
  APPLICATION_MANUALLY_DECLINED,
  APPLICATION_APPROVED,
  IDENTIFICATION_UNDERWRITING_STARTED,
  INCOME_UNDERWRITING_STARTED,
  UNDERWRITING_PENDING_BIOMETRY_IDENTITY,
  UNDERWRITING_PENDING_TOKEN_CLICK,
  APPROVE_READY,
  APPROVED,
  FORMALIZATION_SUBMITTED,
  FORMALIZATION_FAILED,
  FORMALIZATION_COMPLETED,
  DISBURSEMENT_SUBMITTED,
  DISBURSEMENT_FAILED,
  DISBURSEMENT_COMPLETED,
  CANCELLED_BY_DISBURSEMENT_RETURN,
  DISBURSEMENT_RETURN_REQUESTED,
  DISBURSEMENT_RETURNED,
  CURRENT,
  LATE,
  COLLECTION_SUSPENDED,
  RESCHEDULED,
  CURED,
  RECOVERED,
  RE_PAYMENT_PENDING_CONFIRMATION,
  RENEGOTIATED,
  ON_TIME_FULLY_PAID_OFF,
  LATE_FULLY_PAID_OFF,
  CHARGED_OFF,
};
